module.exports = __webpack_public_path__ + "assets/popup-pointer-green.svg";